import React from 'react';
import './Solution.css';

const Solution = () => {
  const solutions = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: '採用',
      subtitle: 'Recruitment',
      description: 'エンジニア採用代行、面談対応、採用基準策定、キャリア支援。年間50名以上の採用実績。',
      features: ['採用面談代行', '採用基準策定', 'キャリア支援']
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: '営業',
      subtitle: 'Sales',
      description: 'SES/受託開発の法人営業代行、案件管理、顧客折衝。年間売上1.2億円の実績。',
      features: ['法人営業代行', '案件進捗管理', '顧客折衝']
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 10V15C22 15.5304 21.7893 16.0391 21.4142 16.4142C21.0391 16.7893 20.5304 17 20 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M22 5C22 5.53043 21.7893 6.03914 21.4142 6.41421C21.0391 6.78929 20.5304 7 20 7H4C3.46957 7 2.96086 6.78929 2.58579 6.41421C2.21071 6.03914 2 5.53043 2 5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: '育成',
      subtitle: 'Training',
      description: 'オンボーディング設計、研修運営、評価制度構築。組織の成長を加速します。',
      features: ['オンボーディング', '研修運営', '評価制度構築']
    }
  ];

  return (
    <section id="solution" className="solution">
      <div className="container">
        <div className="solution__header animate-on-scroll">
          <h2 className="solution__title">
            3つの領域で<br />
            経営者の時間を創出
          </h2>
          <p className="solution__subtitle">
            営業・採用・育成を一気通貫でサポート
          </p>
        </div>

        <div className="solution__grid">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="solution__card animate-on-scroll"
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              <div className="solution__card-circle">
                <div className="solution__card-icon">
                  {solution.icon}
                </div>
              </div>
              
              <div className="solution__card-content">
                <h3 className="solution__card-title">{solution.title}</h3>
                <p className="solution__card-subtitle">{solution.subtitle}</p>
                <p className="solution__card-description">{solution.description}</p>
                
                <ul className="solution__card-features">
                  {solution.features.map((feature, idx) => (
                    <li key={idx} className="solution__card-feature">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="solution__card-number">
                0{index + 1}
              </div>
            </div>
          ))}
        </div>

        <div className="solution__cta animate-on-scroll" style={{ animationDelay: '0.4s' }}>
          <p className="solution__cta-text">
            実務経験に基づく<strong>現場起点の支援</strong>で、<br className="mobile-break" />
            経営者を本来の仕事に集中させます
          </p>
        </div>
      </div>
    </section>
  );
};

export default Solution;